var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolFreehand = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cy: 4.24,
  cx: 14.306,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.432 3.997-1.19-.412M12.388 3.609l-1.53-.34M10.955 3.293l-1.214-.146M9.984 3.196l-1.895-.049M8.308 3.123l-1.433.146M7.021 3.22l-1.433.437M5.855 3.56l-1.117.486M4.835 3.997l-.534.34M4.471 4.192l-.583.534M3.961 4.605l-.583.752M3.548 5.139l-.632 1.044M3.038 5.868 2.771 6.96M2.819 6.742l-.146.971M2.673 7.616l.025 1.069M2.698 8.612l.194 1.141M2.843 9.535l.292 1.19M3.086 10.579l.51 1.069M3.499 11.502l.777 1.02M4.131 12.376l1.7 1.554M5.734 13.882l1.53.826M7.069 14.61l1.895.729M8.818 15.315l2.064.267M10.785 15.582l1.239-.122M11.878 15.485l1.214-.365M12.898 15.218l.971-.632M13.699 14.756l.899-.923M14.549 13.882l.632-1.166M15.157 12.813l.364-1.384"
}), /*#__PURE__*/React.createElement("circle", {
  cy: 10.968,
  cx: 15.521,
  r: 1
}))));
export { SvgToolFreehand as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-freehand.svg";